import { reactive } from 'vue'
import { createContextMenuStore } from '@zoryn/components/grid/src/methods/row-context-menu'
import type { GridTreeInternalData, GridTreeOptions, GridTreeReactData } from './types'

export function createInternalData(): GridTreeInternalData {
  return {
    titleList: [],
    visibleColumns: [],
    allColumns: [],
    flatSource: [],
    allTableData: [],
    expandSet: new Set(),
    rowDomMaps: {},
    hoverRowId: null,
  }
}

export function createReactData(options: GridTreeOptions): GridTreeReactData {
  return reactive<GridTreeReactData>({
    currentPage: options.params?.currentPage ?? 1,
    pageSize: options.params?.pageSize ?? 10,
    pageSizes: (options.params?.pageSizes as number[]) ?? [10, 30, 50, 100],
    total: 0,
    tableData: [],
    currentRow: null,
    editStr: '',
    loading: false,
    loadError: false,
    loadErrorMsg: '',
    filterVisible: false,
    filterList: [],
    editStore: {
      actived: {
        row: null,
        field: null,
      },
    },
    footerTableData: [],
    isAllSelected: false,
    isIndeterminate: false,
    checkboxRecordsCount: 0,
    updateCheckboxFlag: 0,
    initStore: { import: false, export: false, custom: false, columnMenu: false, contextMenu: false },
    columnMenuStore: {
      visible: false,
      columnId: null,
      referenceEl: null,
      sortOrder: null,
      draftFixed: '',
      draftVisible: true,
      filterMode: '',
      filterKeyword: '',
      filterSelected: [],
    },
    contextMenuStore: createContextMenuStore(),
    importStore: {
      visible: false,
      file: null,
      type: '',
      filename: '',
      modeList: [],
      typeList: [],
    },
    importParams: { mode: 'insertTop', types: ['csv'], modes: ['insertTop', 'covering'] },
    exportStore: {
      visible: false,
      columns: [],
      modeList: [],
      typeList: [],
      isPrint: false,
      hasFooter: false,
      hasMerge: false,
      hasTree: true,
      hasColgroup: false,
    },
    exportParams: {
      filename: '',
      sheetName: '',
      mode: 'current',
      type: 'csv',
      isHeader: true,
      isFooter: false,
    },
    customStore: {
      open: false,
      keyword: '',
      columns: [],
      highlightColumnId: null,
      snapshot: [],
    },
    validErrorMaps: {},
  })
}
